import api from '../lib/api'
import assign from 'lodash.assign'
import global from '../types/global.types'
import login from '@edu-fe/login'
import { getInfomation } from '../lib/shareByApp'

const name = 'preferential'

export default {
  name,
  namespaced: true,
  state: {
    couponList: [],
    couponInfo: {},
    couponCourses: [],
    totalValue: 0,
    couponPopList: [],
    data: {}
  },
  getters: {},
  mutations: {
    set (state, data) {
      assign(state, data)
    }
  },
  actions: {
    async init ({ dispatch }) {
      // await dispatch('checkLogin')
      await dispatch('getInfo')
    },
    async checkLogin () {
      const wpsSid = await login.getWpsSid()
      if (!wpsSid) {
        login.login()
      }
    },
    async createLooper({ dispatch }) {
      let timer = setInterval(() => {
        getInfomation().then(data => {
          // this.wpsSid = data.wpsid
          if(data && data.wpsid) {
            dispatch('getInfo')
            clearInterval(timer)
          }
        })
      }, 300)
    },
    async getInfo ({ commit, dispatch }) {
      try {
        const { data, code } = await api.preferential.getInfo()
        if (code === -2) {
          login.login()
          dispatch('createLooper')
        } else if (data) {
          commit('set', {
            couponInfo: data.couponInfoVo || {},
            couponCourses: data.couponCourseVos,
            couponPopList: data.couponPopList || []
          })
        } else  {
          commit(global.ERR, { message: '抱歉，获取信息出错，请稍后再试！' }, { root: true })
        }
      } catch (e) {
        commit(global.ERR, { message: '抱歉，获取信息出错，请稍后再试！' }, { root: true })
      }
    }
  }
}
